import { Link } from "react-router-dom";
import { SignIn, SignUp } from "@clerk/react";
import { Logo } from "@/components/common";

export default function AuthPage({ mode }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#FAFAF7]" data-testid={`auth-page-${mode}`}>
      <div className="hidden lg:flex relative flex-col justify-between p-10 bg-[#0D5C46] text-white overflow-hidden">
        <img src="/images/kitchen-team.jpg" alt="" className="absolute inset-0 h-full w-full object-cover opacity-25" />
        <div className="relative"><Logo light /></div>
        <div className="relative max-w-md">
          <h2 className="text-4xl font-extrabold tracking-tight leading-tight">Je hele team, één simpele app.</h2>
          <p className="mt-3 text-emerald-50/90">Planning, klokken, uren en mededelingen voor jouw horecazaak.</p>
        </div>
      </div>
      <div className="flex flex-col items-center justify-center p-4 py-10">
        <div className="lg:hidden mb-6"><Link to="/"><Logo /></Link></div>
        {mode === "in" ? (
          <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp />
        ) : (
          <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />
        )}
      </div>
    </div>
  );
}
